import { UserDocument } from "../../../coreIdAPI";

let getWholeName = (userDocument: UserDocument) => {
  return `${userDocument.firstName || ""} ${userDocument.lastName || ""} `;
};

export { getWholeName };
